/**
 * 課題録音ボタンを押したときに動画を移動させる先（秒）を決める。
 *   - 通常のDay：動画の終わりの1秒前（課題は最後の1秒に書かれている）
 *   - 複数課題のDay：ボタンごとに決めた時刻（practice_assignment_marks.seek_seconds）
 * ちょうど終端にすると ended 状態になり、ブラウザによって黒い画面になるので、終端までは行かない。
 *
 * @param {{ duration: number, seekSeconds?: number|null }} p
 * @returns {number|null} 移動先の秒数。動画の長さが分からない（読み込み前）場合は null＝移動しない
 */
export const END_OFFSET_SECONDS = 1

export function computeAssignmentSeekSeconds({ duration, seekSeconds = null }) {
  const d = Number(duration)
  if (!Number.isFinite(d) || d <= 0) return null
  if (seekSeconds != null && Number.isFinite(Number(seekSeconds))) {
    const t = Number(seekSeconds)
    // 指定が動画の長さを超えていたら、終端の手前に収める
    return Math.min(Math.max(0, t), Math.max(0, d - 0.1))
  }
  return Math.max(0, d - END_OFFSET_SECONDS)
}

/** API から来たマーク一覧を画面用に整える（part_no 順、不正な行は捨てる） */
export function normalizeAssignmentMarks(raw) {
  if (!Array.isArray(raw)) return []
  return raw
    .map((m) => ({
      partNo: Number(m?.partNo),
      label: typeof m?.label === 'string' && m.label.trim() ? m.label.trim() : null,
      seekSeconds: Number(m?.seekSeconds)
    }))
    .filter((m) => Number.isInteger(m.partNo) && m.partNo >= 1 && Number.isFinite(m.seekSeconds) && m.seekSeconds >= 0)
    .map((m) => ({ ...m, label: m.label || `課題${m.partNo}` }))
    .sort((a, b) => a.partNo - b.partNo)
}
